export const useCapabilitiesServiceStore = () => {
  const uid = useCurrentUID();

  if (!uid) {
    throw new Error("uid is not defined");
  }

  return useCapabilitiesService(uid)();
};
